import { render, staticRenderFns } from "./widget-show-attachment.vue?vue&type=template&id=05f5d8af&"
import script from "./widget-show-attachment.vue?vue&type=script&lang=js&"
export * from "./widget-show-attachment.vue?vue&type=script&lang=js&"
import style0 from "./widget-show-attachment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports